<template>
    <transition name="modal" appear>
        <div class="modal" role="dialog" aria-modal="true" aria-labelledby="info-title">
            <header class="modal-header">
                <div class="title">
                    <img :src="require('@/assets/images/website/zappelin-logo.png')" alt="Zappelin logo" />
                    <h1 id="info-title">De Boterhamshow informatie</h1>
                </div>
                <button class="close-button" aria-label="Sluiten" @click="closeModal">
                    <svg aria-hidden="true" height="24px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="24px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/></svg>
                </button>
            </header>
            <div class="modal-body">
                <p class="info-text">Welkom op de site van de Boterhamshow! Sinds 2023 worden er helaas geen nieuwe afleveringen meer gemaakt en wordt ook deze site niet meer actief geüpdatet. Het kan daarom zijn dat sommige onderdelen in de loop der tijd niet meer (helemaal) naar behoren werken. Omdat het een archief-site betreft voldoet deze helaas niet aan alle huidige eisen wat betreft WCAG en toegankelijkheid. Onze excuses daarvoor.</p>
                <p class="info-text">Veel plezier op de site! De afleveringen van de Boterhamshow zijn nog steeds beschikbaar om te <a href="https://npo.nl/start/serie/de-boterhamshow/afleveringen" target="_blank" rel="noopener noreferrer" class="info-text__link">bekijken op NPO Start<span class="sr-only"> (opent in nieuw tabblad)</span></a> en de podcast is hier op deze site te beluisteren.</p>
            </div>
        </div>
    </transition>
</template>

<script>
    import { focusTrap } from '@/mixins/focusTrap'
    import { lockScroll, unlockScroll } from '@/utils/scrollLock'
	export default {
        mixins: [focusTrap],

        mounted () {
            smarttag && smarttag('info')
            lockScroll()
        },

        beforeDestroy () {
            unlockScroll()
        },

        methods: {
            closeModal () {
                this.$router.push('/')
            }
        }
	}
</script>

<style lang="scss" scoped>

.modal {
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -25%;
    width: 50%;
    height: auto;
    z-index: 3002;
    background-color: #292f36;
    transform: translateY(-50%);
    border-radius: 6px;
}

h1 {
    font-family: 'bariol-bold';
    font-weight: normal;
    font-size: 26px;
    margin: 0 0 0 10px;
    line-height: 1.2;
}

.modal-header {
    border-radius: 6px 6px 0 0;
    display: flex;
    background: white;
    padding: 20px;
    justify-content: space-between;
    align-items: center;
}

.title {
    display: flex;
    align-items: center;
    img {
        width: 80px;
        height: auto;
        margin-right: 15px;
        flex-shrink: 0;
    }
}

.close-button {
    background: none;
    border: 0;
    outline: 0;
    cursor: pointer;
    padding: 20px 0 20px 10px;
    margin: 0;
    flex-shrink: 0;

    &:focus-visible {
        outline: 3px solid #292f36;
        outline-offset: 2px;
        border-radius: 4px;
    }
}

.modal-body {
    padding: 24px;
}

.info-text {
    font-family: 'bariol-regular';
    font-size: 16px;
    color: #ffffff;
    line-height: 1.6;
    margin: 0 0 16px 0;

    &:last-child {
        margin-bottom: 0;
    }
}

.info-text__link {
    color: #ffffff;
    text-decoration: underline;

    &:hover {
        text-decoration: none;
    }
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .3s, transform .5s;
}
.modal-enter, .modal-leave-to {
  opacity: 0;
  transform: translateY(100px);
}
</style>



// WEBPACK FOOTER //
// InfoModal.vue?5d59e8e0